export default __webpack_public_path__ + "static/Spoiled_Meat-04be98e8122b73b0cb3ac0f00c33179e.png";